module.exports = __webpack_public_path__ + "static/media/dashboard_dark.1594b085.svg";